import { useMutation } from '@tanstack/react-query';

import { agent } from 'api/agent';

const deleteAccountMutation = () => useMutation({
  mutationKey: ['deleteAccount'],
  mutationFn: (_: null) => agent.getClient().delete('/auth/me'),
  onSuccess: () => { },
});

export default deleteAccountMutation;
